"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Help = function Help(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M16 5.5H8C7.93432 5.49993 7.86927 5.51282 7.80858 5.53792C7.74788 5.56302 7.69274 5.59985 7.64629 5.64629C7.59985 5.69274 7.56302 5.74788 7.53792 5.80858C7.51282 5.86927 7.49993 5.93432 7.5 6V18C7.5 18.1326 7.55268 18.2598 7.64645 18.3536C7.74021 18.4473 7.86739 18.5 8 18.5H16C16.0171 18.5 16.0341 18.4991 16.0511 18.4974C16.0669 18.4958 16.0824 18.4935 16.0977 18.4904C16.2112 18.4678 16.3132 18.4066 16.3866 18.3172C16.4599 18.2278 16.5 18.1157 16.5 18V6C16.5 5.86739 16.4473 5.74022 16.3536 5.64645C16.2598 5.55268 16.1326 5.5 16 5.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12 15.625C12.3452 15.625 12.625 15.3452 12.625 15C12.625 14.6548 12.3452 14.375 12 14.375C11.6548 14.375 11.375 14.6548 11.375 15C11.375 15.3452 11.6548 15.625 12 15.625Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M10.5 11C10.7761 11 11 10.7761 11 10.5C11 10.2239 10.7761 10 10.5 10C10.2239 10 10 10.2239 10 10.5C10 10.7761 10.2239 11 10.5 11Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12 12.5C12.2761 12.5 12.5 12.2761 12.5 12C12.5 11.7239 12.2761 11.5 12 11.5C11.7239 11.5 11.5 11.7239 11.5 12C11.5 12.2761 11.7239 12.5 12 12.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12 13.5C12.2761 13.5 12.5 13.2761 12.5 13C12.5 12.7239 12.2761 12.5 12 12.5C11.7239 12.5 11.5 12.7239 11.5 13C11.5 13.2761 11.7239 13.5 12 13.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12 8.5C11.4697 8.5006 10.9614 8.7115 10.5864 9.08644C10.2115 9.46139 10.0006 9.96975 10 10.5H11C11 10.3022 11.0586 10.1089 11.1685 9.94443C11.2784 9.77998 11.4346 9.65181 11.6173 9.57612C11.8 9.50043 12.0011 9.48063 12.1951 9.51922C12.3891 9.5578 12.5673 9.65304 12.7071 9.79289C12.847 9.93275 12.9422 10.1109 12.9808 10.3049C13.0194 10.4989 12.9996 10.7 12.9239 10.8827C12.8482 11.0654 12.72 11.2216 12.5556 11.3315C12.3911 11.4414 12.1978 11.5 12 11.5V12.5C12.5304 12.5 13.0391 12.2893 13.4142 11.9142C13.7893 11.5391 14 11.0304 14 10.5C14 9.96957 13.7893 9.46086 13.4142 9.08579C13.0391 8.71071 12.5304 8.5 12 8.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12.5 12H11.5V13H12.5V12Z",
    fill: props.foregroundColor
  }));
};

Help.defaultProps = {
  altText: "Help",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
Help.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Help;
exports.default = _default;